import {createAnalysis} from 'analysis-tool/AnalysisActions';
import {CreateAnalysisParams, CreateAnalysisResponse} from 'analysis-tool/AnalysisDAO';
import {ActionOrigin} from 'constants/AnalyticsConstants';
import {StudyType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {logProfilerTimingEvent} from 'performance/BenchlingProfiler';
import {
  STUDIES_GENERATE_ANALYSIS_STARTED_EVENT,
  STUDIES_GENERATE_ANALYSIS_ENDED_EVENT,
  composeStudiesGenerateAnalysisEventMetadata,
} from 'performance/processStudiesEvents';

/**
 * Create analysis for study with perf metadata.
 *
 * @param data Data for create analysis
 * @param actionOrigin Action origin for metrics
 * @param withBackgroundSeedData Whether to seed data in the background (progress toast) rather than
 * navigating to the analysis. Defaults to false.
 */
export async function createAnalysisForStudy(
  data: CreateAnalysisParams,
  metadata: {actionOrigin: ActionOrigin; studyType: StudyType | null},
  withBackgroundSeedData: boolean = false
): Promise<CreateAnalysisResponse> {
  logProfilerTimingEvent(STUDIES_GENERATE_ANALYSIS_STARTED_EVENT);
  const analysisResults = await createAnalysis(data, undefined, withBackgroundSeedData);
  const eventMetadata = composeStudiesGenerateAnalysisEventMetadata(
    metadata.actionOrigin,
    metadata.studyType
  );
  logProfilerTimingEvent(STUDIES_GENERATE_ANALYSIS_ENDED_EVENT, eventMetadata);
  return analysisResults;
}
